import { createFileRoute } from '@tanstack/react-router'
import { FreeSWITCHServersPage } from '@/features/freeswitch'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/freeswitch/servers/')({
  component: FreeSWITCHServersPage,
  beforeLoad: requireRole(['admin']),
})
